/**
 * Service worker kayit KARARI — saf fonksiyon (docs/faz5-arayuz-spec.md §1:
 * "basit service worker"). `main.tsx` `import.meta.env.PROD` VE
 * `"serviceWorker" in navigator` kosullarini burada tekrar SINAMAK yerine
 * dogrudan bu fonksiyona devreder — boylece kayit KARARI (main.tsx'i
 * calistirmadan) birim test edilebilir.
 */
export interface SwRegistrationPlan {
  url: string;
  scope: string;
}

export function swRegistrationPlan(
  base: string,
  isProd: boolean,
  hasServiceWorkerSupport: boolean,
): SwRegistrationPlan | null {
  if (!isProd || !hasServiceWorkerSupport) return null;
  return { url: `${base}sw.js`, scope: base };
}
